import { Fragment, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router";
import { valdiatePage } from "../../global";
import { getInternationalCNs, generateInternationalAddressLabels } from '../../services/internationaladdresslabelservice';
import { getSubAccountLocations } from '../../services/userservice';
import { useSelector, useDispatch } from "react-redux";
import { setLoading } from "../../redux/appSlice";
import { setData, reset, setLocations, setGrid, updateGrid as updateG, setType, updateGridObject } from "../../redux/addressLabelSlice";
import Pagination from '../../components/paginations';
import SeeMoreModal from "../../components/SeeMoreModal";

const InternationalAddressLabel = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const state = useSelector(state => {
        return { appData: state.appData, addressLabelData: state.addressLabelData }
    })
    const { userInfo, loading, subaccounts } = state.appData;

    const { data, locations, grid, type } = state.addressLabelData;

    const [page, setPage] = useState(0);
    const [pageLimit, setPageLimit] = useState(50);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [originalGrid, setOriginalGrid] = useState([]);
    
    const searchObjInit = {
        cn: '',
        consignee: '',
        bookingDate: ''
    };


    const [searchObject, setSearchObj] = useState(searchObjInit);
    const updateSearchData = (key, val) => setSearchObj(prev => { return { ...prev, [key]: val } });



    const gridKeys = [
        {
            key: '', 
            name: <input className="form-check-input" type="checkbox" checked={grid.length === grid.filter(y => y.selected).length} onChange={(e) => {
                        const g = grid.map(y => {
                            return { ...y, selected: e.target.checked }
                        });
                        dispatch(setGrid({ data: g }));
                    }} />, 
            searchBox: false, 
            visible: true
        },
        {key: 'cn', name: 'Consignment No', searchBox: true, visible: true},
        {key: 'consignee', name: 'Consignee', searchBox: true, visible: true},
        {key: 'pieces', name: 'Pieces', searchBox: false, visible: true},
        {key: 'weight', name: 'Weight', searchBox: false, visible: true},
        {key: 'refNo', name: 'Reference No', searchBox: false, visible: true},
        {key: 'bookingDate', name: 'Booking Date', searchBox: true, visible: true},
        {key: 'serviceType', name: 'Service Type', searchBox: false, visible: true},
        {key: 'codAmount', name: 'Cod Amount', searchBox: false, visible: true},
        {key: 'productDetails', name: 'Product Details', searchBox: false, visible: true},
        {key: 'remarks', name: 'Remarks', searchBox: false, visible: true},
        {key: '', 
            name: <button type="button" className="btn btn-sm btn-primary" onClick={async () => {
            const d = grid.filter(c => c.selected);
            if (d.length > 0) {
                await generateLabels(d);
            } else {
                alert('Select Consignments');
            }
        }}>Combined Address Label</button>, searchBox: false, visible: true}

    ]
    
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
          direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    let filterData = useMemo(() => {
        return grid.filter((item, index) => {
            return (index >= page * pageLimit) & (index < (page + 1) * pageLimit);
        })
    }, [page, grid, pageLimit, grid.length]);

    const sortedArray = [...filterData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });

    useEffect(() => {
        if (valdiatePage('/internationaladdresslabel')) {

        } else {
            history.push('/login');
        }
        return () => {
            dispatch(reset({}));
            dispatch(setGrid({ data: [] }));
        }
    }, []);

    const updateData = (key, val) => dispatch(setData({ data: { ...data, [key]: val } }));

    const onSearch = async () => {
        if (!data.locationId) {
            alert('Select Location');
            return;
        }

        if (!data.from) {
            alert('Select From Date');
            return;
        }

        if (!data.to) {
            alert('Select To Date');
            return;
        }

        const from = Date.parse(data.from);
        const to = Date.parse(data.to);

        if (from > to) {
            alert('Invalid Date');
            return;
        }

        dispatch(setLoading({ data: true }));
        const rs = await getInternationalCNs(data);
        dispatch(setLoading({ data: false }));
        if (rs.sts > 0) {
            alert(rs.msg);
            dispatch(setGrid({ data: [] }))
        } else {
            if (rs.data && rs.data.length > 0) {
                setOriginalGrid(rs.data);
                dispatch(setGrid({ data: rs.data }));                
            } else {
                alert('No Data Found');
            }
        }
    }

    const updateGrid = (index, key, val) => {
        dispatch(updateG({ index, key, val }));
    }

    const generateLabels = async (data) => {
        //const dt = { CNs: data.map(x => x.cn) };
        const dt = data.map(x => x.cn);
        const rs = await generateInternationalAddressLabels(dt);
        if (rs.ok) {
            sessionStorage.setItem('type', type);
            sessionStorage.setItem('intllabeldata', JSON.stringify(rs.data));
            window.open('/cplight/intladdresslabel.html', '_blank');
            const g = [...grid];
            dispatch(setGrid({ data: g }));
        }
        else {
            alert(rs.msg);
        }
    }

    const onGenerateLabels = async (x) => {
        await generateLabels([x]);
    }

    return userInfo && <section className="section">
        <div className="section-header">
            <h1>International  Address Label</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>
            <div className="row">
                <div className="col-lg-2">
                    <label>Sub Account</label>
                    <select className="form-select" value={data.subAccountId} onChange={async (e) => {
                        const val = e.target.value;
                        dispatch(setData({ data: { ...data, subAccountId: val, locationId: '' } }));
                        if (val) {
                            const accno = e.target[e.target.selectedIndex].getAttribute('data-accno');
                            const locs = await getSubAccountLocations(userInfo.id, val)
                            if (locs)
                                dispatch(setLocations({ data: locs }));
                        } else {
                            dispatch(setLocations({ data: [] }));
                        }
                    }}>
                        <option value="" data-accno="">Select Sub Account</option>
                        {
                            subaccounts.map((x, index) => <option key={index} value={x.id} data-accno={x.accountNo}>{x.name}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg-2">
                    <label>Locations</label>
                    <select className="form-select" value={data.locationId} onChange={(e) => updateData('locationId', e.target.value)}>
                        <option value="">Select Location</option>
                        {
                            locations.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg-2">
                    <label>Order From</label>
                    <input type="datetime-local" className="form-control" value={data.from} onChange={(e) => updateData('from', e.target.value)} />
                </div>
                <div className="col-lg-2">
                    <label>Order To</label>
                    <input type="datetime-local" className="form-control" value={data.to} onChange={(e) => updateData('to', e.target.value)} />
                </div>
                <div className="col-lg-2">
                    <button type="button" className="btn btn-primary mt-3" onClick={onSearch} disabled={loading}>
                        Search
                    </button>
                </div>
            </div>
            {
                originalGrid.length > 0 &&
                <div className="row mt-3">
                    <div className="col-12">
                    {
                        <Pagination
                            setGrid={(result) => {
                                dispatch(setGrid({data: result}));
                            }}                                
                            searchObjInit={searchObjInit}
                            searchObject={searchObject}
                            originalGrid={originalGrid}
                            setPage={setPage}
                            setPageLimit={setPageLimit}
                            requestSort={requestSort}
                            sortConfig={sortConfig}
                            updateSearchData={updateSearchData}
                            sortedArray={sortedArray}
                            data={data}
                            dataCount={grid.length}
                            pageLimit={pageLimit}  
                            gridKeys={gridKeys}
                            page={page}
                            grid={
                            sortedArray && sortedArray.length > 0 && sortedArray.map((x, index) =>
                                    <Fragment key={index}>
                                        <tr>
                                            <td>{(index + 1)+(page*pageLimit)}</td>
                                            <td style={{ position: 'relative' }}>
                                                <input className="form-check-input" checked={x.selected} type="checkbox" onChange={(e) => {
                                                    let objIndex = -1;
                                                    for (let i = 0; i < grid.length; i++) {
                                                        if (grid[i]['cn'] === x.cn) {
                                                            objIndex = i;
                                                            break;
                                                        }
                                                    }
                                                    updateGrid(objIndex, 'selected', e.target.checked)
                                                }} />
                                            </td>
                                            <td>{x.cn}</td>
                                            <td>
                                                {x.consignee}
                                            </td>
                                            <td>
                                                {x.pieces}
                                            </td>
                                            <td>
                                                {x.weight}
                                            </td>
                                            <td>
                                                {x.refNo}
                                            </td>
                                            <td>{x.bookingDate}</td>
                                            <td>
                                                {x.serviceType}
                                            </td>
                                            <td>
                                                {x.codAmount}
                                            </td>
                                            <td style={{ minWidth: 300 }}>
                                                <SeeMoreModal detail={x.productDetails} maxLength={120} />
                                            </td>
                                            <td style={{ minWidth: 300 }}>
                                                <SeeMoreModal detail={x.remarks} maxLength={120} />
                                            </td>
                                            <td style={{ minWidth: 200 }}>
                                                <button type="button" className="btn btn-sm btn-primary" onClick={async (e) => { await onGenerateLabels(x) }}>Generate Address Label</button>
                                            </td>
                                        </tr>
                                    </Fragment>
                                )
                                    
                                }
                            />
                            }           
                    </div>
                </div>
            }
        </div>
    </section >
}

export default InternationalAddressLabel;